import { API_SET_CASE_STATUS, API_CASES_MARK_AS_DISCUSS } from "../../config";
import httpClient from "../../httpClient";

export const setCaseStatus = {
    create: (data) => httpClient.post(API_SET_CASE_STATUS, data),
};

export const caseMarkAsDiscuss = {
    post: (data) => httpClient.post(API_CASES_MARK_AS_DISCUSS, data),
};